var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuBridgeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1600,
    height: 900,
    viewBox: "0 0 1600 900",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(Infinity NaN NaN Infinity 0 0)",
    id: "7bccbb58-8772-4a86-b08f-e1bb51101b07"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 800 450)",
    id: "1d12589b-5c32-4789-b2f2-4902e67d8ecf"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -800,
    y: -450,
    rx: 0,
    ry: 0,
    width: 1600,
    height: 900
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.91 0 0 1.91 820.45 52.87)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)",
    id: 4672
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.63 0 0 0.34 -16.64 227.43)",
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeOpacity: 0,
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(249,247,252)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -750,
    y: -750,
    rx: 0,
    ry: 0,
    width: 1500,
    height: 1500
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29 0 0 1.29 8.32 463.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -50,
    y: -50,
    rx: 0,
    ry: 0,
    width: 100,
    height: 100
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29 0 0 1.29 -192.29 216.48)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(237,13,54)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-144.34, -108.5)",
    d: "M 97.383 1.932 C 48.259 5.406 9.015 44.65 5.54 93.774 C 5.269 97.607 8.295 100.871 12.138 100.871 L 97.867 100.871 C 101.51942080497658 100.87044777428987 104.48000004174673 97.90942084672328 104.48 94.25699999999999 L 104.48 8.53 C 104.48 4.686999999999999 101.217 1.6629999999999994 97.38300000000001 1.9319999999999995 M 218.93900000000002 94.352 C 215.46500000000003 45.229000000000006 176.221 5.984999999999999 127.09700000000002 2.5120000000000005 C 123.264 2.24 120 5.265 120 9.108 L 120 94.837 C 120.00055222571012 98.48942080497658 122.96157915327672 101.45000004174673 126.614 101.45 L 212.341 101.45 C 216.184 101.45 219.208 98.187 218.93900000000002 94.35300000000001 Z M 209.579 114.45500000000001 C 160.455 117.92900000000002 121.21100000000001 157.173 117.73700000000001 206.296 C 117.46600000000001 210.13 120.492 213.394 124.33500000000001 213.394 L 210.06400000000002 213.394 C 213.7164208049766 213.39344777428988 216.67700004174674 210.4324208467233 216.67700000000002 206.78 L 216.67700000000002 121.053 C 216.67700000000002 117.21 213.41400000000002 114.18599999999999 209.58 114.455 Z M 5.54 123.227 C 9.014 172.35 48.258 211.594 97.382 215.067 C 101.215 215.339 104.479 212.31300000000002 104.479 208.47 L 104.479 122.741 C 104.47844777428988 119.08857919502343 101.51742084672328 116.12799995825327 97.865 116.128 L 12.138 116.128 C 8.295 116.128 5.271 119.391 5.54 123.225 Z M 259.075 123.81 L 259.805 123.81 L 283.165 172.39 L 274.65500000000003 172.39 L 270.495 162.88 L 248.255 162.88 L 244.095 172.39 L 235.845 172.39 Z M 259.405 137.87 L 256.505 144.47 L 251.225 156.22 L 267.59499999999997 156.22 L 262.37499999999994 144.54 L 259.53499999999997 137.87 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29 0 0 1.29 -43.23 268.17)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -23.66,
    y: -24.29,
    rx: 0,
    ry: 0,
    width: 47.32,
    height: 48.58
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29 0 0 1.29 11.64 267.98)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(237,13,54)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-302.57, -148.47)",
    d: "M 302.575 173.05 Q 296.235 173.05 292.445 170.47 Q 288.645 167.9 286.965 163.08 Q 285.275 158.26000000000002 285.275 151.66000000000003 L 285.275 123.88000000000002 L 292.67499999999995 123.88000000000002 L 292.67499999999995 151.8 Q 292.67499999999995 159.52 295.01499999999993 162.85000000000002 Q 297.3549999999999 166.18000000000004 302.57499999999993 166.18000000000004 Q 307.7849999999999 166.18000000000004 310.0949999999999 162.95000000000005 Q 312.4049999999999 159.72000000000006 312.4049999999999 151.80000000000004 L 312.4049999999999 123.88000000000004 L 319.8649999999999 123.88000000000004 L 319.8649999999999 151.66000000000003 Q 319.8649999999999 161.83 315.6349999999999 167.44000000000003 Q 311.41499999999985 173.05000000000004 302.5749999999999 173.05000000000004",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29 0 0 1.29 12.27 268.64)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -17.295,
    y: -24.585,
    rx: 0,
    ry: 0,
    width: 34.59,
    height: 49.17
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29 0 0 1.29 88.33 267.58)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(237,13,54)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-362.07, -148.13)",
    d: "M 345.735 172.39 L 345.735 123.88 L 358.075 123.88 Q 364.015 123.88 367.485 125.07 Q 370.945 126.25 372.635 128.1 Q 374.315 129.95 374.84499999999997 132 Q 375.36499999999995 134.04 375.36499999999995 135.82 Q 375.36499999999995 137.73999999999998 374.80499999999995 139.82 Q 374.24499999999995 141.9 372.92499999999995 143.64 Q 371.60499999999996 145.39 369.29499999999996 146.45 Q 374.24499999999995 147.7 376.32499999999993 150.76999999999998 Q 378.4049999999999 153.83999999999997 378.4049999999999 157.6 Q 378.4049999999999 160.18 377.81499999999994 162.82 Q 377.2149999999999 165.45999999999998 375.3349999999999 167.6 Q 373.4549999999999 169.75 369.69499999999994 171.07 Q 365.93499999999995 172.39 359.5949999999999 172.39 Z M 352.995 144.46999999999997 L 359.265 144.46999999999997 Q 362.695 144.46999999999997 364.54499999999996 143.30999999999997 Q 366.395 142.15999999999997 367.155 140.30999999999997 Q 367.91499999999996 138.45999999999998 367.91499999999996 136.42 Q 367.91499999999996 134.7 367.155 133.28 Q 366.395 131.86 364.445 131.01 Q 362.495 130.14999999999998 358.935 130.14999999999998 L 352.995 130.14999999999998 Z M 352.995 166.17999999999998 L 360.585 166.17999999999998 Q 363.955 166.17999999999998 365.965 165.39 Q 367.97499999999997 164.6 369.03499999999997 163.35 Q 370.085 162.09 370.41499999999996 160.60999999999999 Q 370.74499999999995 159.11999999999998 370.74499999999995 157.67 Q 370.74499999999995 154.23999999999998 368.43499999999995 152.29 Q 366.12499999999994 150.34 361.17499999999995 150.34 L 352.99499999999995 150.34 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29 0 0 1.29 88.96 268.21)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -16.335,
    y: -24.255,
    rx: 0,
    ry: 0,
    width: 32.67,
    height: 48.51
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29 0 0 1.29 141.28 267.58)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(237,13,54)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-403.16, -148.13)",
    d: "M 386.785 172.39 L 386.785 123.88 L 397.805 123.88 Q 401.505 123.88 404.975 124.6 Q 408.435 125.33 411.14500000000004 127.05 Q 413.845 128.76 415.43500000000006 131.6 Q 417.01500000000004 134.44 417.01500000000004 138.6 Q 417.01500000000004 143.41 414.77500000000003 146.98 Q 412.52500000000003 150.54 407.975 152.45999999999998 L 419.52500000000003 172.39 L 411.00500000000005 172.39 L 401.24500000000006 154.04 Q 400.11500000000007 154.10999999999999 398.50500000000005 154.14 Q 396.88500000000005 154.17 395.82500000000005 154.17 L 393.98500000000007 154.17 L 393.98500000000007 172.39 Z M 393.985 148.17 L 398.665 148.17 Q 402.295 148.17 404.505 147.23999999999998 Q 406.715 146.32 407.905 144.89999999999998 Q 409.09499999999997 143.47999999999996 409.525 141.79999999999998 Q 409.955 140.10999999999999 409.955 138.66 Q 409.955 135.43 408.465 133.54999999999998 Q 406.98499999999996 131.67 404.375 130.83999999999997 Q 401.765 130.01999999999998 398.405 130.01999999999998 L 393.98499999999996 130.01999999999998 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29 0 0 1.29 141.92 268.21)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -16.37,
    y: -24.255,
    rx: 0,
    ry: 0,
    width: 32.74,
    height: 48.51
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29 0 0 1.29 177 267.58)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(237,13,54)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-430.88, -148.13)",
    d: "M 427.175 172.39 L 427.175 123.88 L 434.575 123.88 L 434.575 172.39 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29 0 0 1.29 177.66 268.21)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -3.7,
    y: -24.255,
    rx: 0,
    ry: 0,
    width: 7.4,
    height: 48.51
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29 0 0 1.29 219.04 267.58)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(237,13,54)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-463.48, -148.13)",
    d: "M 444.475 172.39 L 444.475 123.88 L 456.15500000000003 123.88 Q 462.685 123.88 467.27500000000003 125.33 Q 471.865 126.78 474.83500000000004 129.19 Q 477.80500000000006 131.6 479.485 134.67 Q 481.165 137.73999999999998 481.825 141 Q 482.485 144.27 482.485 147.31 Q 482.485 151.86 481.20500000000004 156.32 Q 479.915 160.76999999999998 476.94500000000005 164.4 Q 473.975 168.03 468.99500000000006 170.21 Q 464.00500000000005 172.39000000000001 456.5450000000001 172.39000000000001 Z M 451.865 165.85 L 457.345 165.85 Q 462.225 165.85 465.555 164.34 Q 468.895 162.82 470.90500000000003 160.21 Q 472.9150000000001 157.60000000000002 473.805 154.34 Q 474.695 151.07 474.695 147.64000000000001 Q 474.695 142.95000000000002 473.045 139.02 Q 471.39500000000004 135.10000000000002 467.605 132.72 Q 463.805 130.35 457.345 130.35 L 451.865 130.35 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29 0 0 1.29 219.69 268.21)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -19.005,
    y: -24.255,
    rx: 0,
    ry: 0,
    width: 38.01,
    height: 48.51
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29 0 0 1.29 279.36 267.52)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(237,13,54)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-510.27, -148.1)",
    d: "M 513.635 173.05 Q 508.16499999999996 173.05 503.575 171.13000000000002 Q 498.985 169.22000000000003 495.655 165.82000000000002 Q 492.325 162.42000000000002 490.505 157.77 Q 488.695 153.12 488.695 147.70000000000002 Q 488.695 142.36 490.53499999999997 137.87 Q 492.385 133.38 495.755 130.08 Q 499.115 126.78000000000002 503.735 124.97000000000001 Q 508.355 123.15000000000002 513.835 123.15000000000002 Q 518.125 123.15000000000002 521.265 123.91000000000003 Q 524.395 124.67000000000003 526.275 125.56000000000003 Q 528.155 126.45000000000003 528.685 126.98000000000003 L 525.785 133.18000000000004 Q 525.3249999999999 132.79000000000005 523.935 132.00000000000003 Q 522.545 131.20000000000002 520.0749999999999 130.54000000000002 Q 517.5949999999999 129.88000000000002 513.7049999999999 129.88000000000002 Q 508.2949999999999 129.88000000000002 504.4649999999999 132.23000000000002 Q 500.63499999999993 134.57000000000002 498.5949999999999 138.53000000000003 Q 496.5449999999999 142.49000000000004 496.5449999999999 147.31000000000003 Q 496.5449999999999 152.92000000000004 498.7849999999999 157.24000000000004 Q 501.0349999999999 161.56000000000003 504.9249999999999 163.97000000000003 Q 508.8249999999999 166.38000000000002 513.7749999999999 166.38000000000002 Q 516.6049999999999 166.38000000000002 519.5449999999998 165.66000000000003 Q 522.4849999999999 164.93000000000004 524.5249999999999 163.21000000000004 L 524.5249999999999 153.84000000000003 L 514.5649999999998 153.84000000000003 L 514.5649999999998 147.04000000000002 L 531.8549999999998 147.04000000000002 L 531.8549999999998 166.05 Q 529.6749999999998 168.82000000000002 524.9949999999998 170.94 Q 520.3049999999997 173.05 513.6349999999998 173.05",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29 0 0 1.29 279.99 268.17)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -21.58,
    y: -24.95,
    rx: 0,
    ry: 0,
    width: 43.16,
    height: 49.9
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29 0 0 1.29 332.81 267.58)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(237,13,54)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-551.75, -148.13)",
    d: "M 540.035 172.39 L 540.035 123.88 L 561.295 123.88 L 561.295 130.35 L 547.365 130.35 L 547.365 143.74 L 558.585 143.74 L 558.585 150.34 L 547.365 150.34 L 547.365 165.85 L 563.465 165.85 L 563.465 172.39 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29 0 0 1.29 333.46 268.21)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -11.715,
    y: -24.255,
    rx: 0,
    ry: 0,
    width: 23.43,
    height: 48.51
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuBridgeLogo);
export default __webpack_public_path__ + "static/media/AUBridge-logo.d995055048dc7d7e6a92216e73034071.svg";
export { ForwardRef as ReactComponent };